import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "@/services/features/auth/authSlice";
import api from "@/services/axios";

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return () => {
    // Was local-only (localStorage clear + redirect) — never told the
    // backend, so the session this device was issued stayed listed as
    // active in GET auth/sessions after "logging out" locally. Fire it
    // off but don't wait on it: the token is about to be cleared either
    // way, and a flaky network shouldn't be able to strand someone on
    // the logout screen.
    api.get("auth/logout").catch(() => {});
    localStorage.clear();
    dispatch(logout());
    navigate("/login");
  };
};
